import { MotifFormField, MotifInput, MotifLabel } from '@ey-xd/motif-react'
import React, { useState, useEffect } from 'react'
import { updateExtraxtedText } from '../AnnotateSlice'
import { useDispatch } from 'react-redux'
interface UserDetailItemProps {
  recordIndex: number
  evidenceId: string
  annotationTypeId?: string;
  personName: string
  personEmail: string
  userGroup: string
  personJob: string
  personDepartment: string
  personId: string
  type: string
  permission: string
  systemAccount: string
  sysAccountDetected: number
  pageNumber?: number // Added 'pageNumber' property
  highlight?: boolean
  evidenceAnnotationId?: string
  originalRecord?: any
}
interface UserInfo {
  personName?: string // Added 'name' property
  personEmail?: string // Added 'email' property
  personId?: string // Added 'id' property
  type?: string // Added 'type' property
  userGroup?: string // Added 'group' property
  personJob?: string // Added 'job' property
  personDepartment?: string // Added 'department' property
  permission?: string // Added 'department' property
  systemAccount?: string // Added 'systemAccount' property
  sysAccountDetected?: number // Added 'department' property
}
export const UserDetail = ({
  evidenceId,
  recordIndex,
  annotationTypeId,
  personName,
  personEmail,
  userGroup,
  personJob,
  personDepartment,
  personId,
  type,
  permission,
  systemAccount,
  sysAccountDetected,
  pageNumber,
  highlight,
  evidenceAnnotationId,
  originalRecord,
}: UserDetailItemProps) => {
  const changed = (field: string, current: any) =>
    originalRecord != null &&
    (current ?? '') !== (originalRecord[field] ?? '')
  const dispatch = useDispatch()
  const [userDetails, setUserDetails] = useState<UserInfo | null>({
    personName: personName ? personName : '',
    personEmail: personEmail? personEmail : '',
    personId: personId? personId : '',
    type: type? type : '',
    userGroup: userGroup? userGroup : '',
    personJob: personJob? personJob : '',
    personDepartment: personDepartment? personDepartment : '',
    permission: permission? permission : '',
    systemAccount: systemAccount? systemAccount : '',
    sysAccountDetected: sysAccountDetected ? sysAccountDetected : 0,
  })
  useEffect(() => {
    setUserDetails({
      personName: personName ? personName : '',
      personEmail: personEmail ? personEmail : '',
      personId: personId ? personId : '',
      type: type ? type : '',
      userGroup: userGroup ? userGroup : '',
      personJob: personJob ? personJob : '',
      personDepartment: personDepartment ? personDepartment : '',
      permission: permission ? permission : '',
      systemAccount: systemAccount ? systemAccount : '',
      sysAccountDetected: sysAccountDetected ? sysAccountDetected : 0,
    })
  }, [personName, personEmail, personId, type, userGroup, personJob, personDepartment, permission, systemAccount, sysAccountDetected])
  useEffect(() => {
    dispatch(
      updateExtraxtedText({
        evidenceId: evidenceId,
        recordIndex: recordIndex,
        annotationTypeId: annotationTypeId,
        extractedText: userDetails,
        pageNumber: pageNumber ? pageNumber : 1, // Use the provided pageNumber or default to 1
        evidenceAnnotationId: evidenceAnnotationId,
      }),
    )
  }, [userDetails])
  const handleUserDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  return (
    <div className={`user-detail-tab${highlight ? ' user-detail-tab--highlight' : ''}`}>
        <div className={changed('personName', userDetails?.personName) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="name" position="in">
            Name
          </MotifLabel>
          <MotifInput
            id="personName"
            label="Name"
            name="personName"
            onChange={handleUserDetailsChange}
            aria-label="name"
            labelPosition="in"
            value={userDetails?.personName}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('personEmail', userDetails?.personEmail) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="email" position="in">
            Email
          </MotifLabel>
          <MotifInput
            id="personEmail"
            name="personEmail"
            onChange={handleUserDetailsChange}
            labelPosition="in"
            value={userDetails?.personEmail}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('userGroup', userDetails?.userGroup) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="group" position="in">
            Group
          </MotifLabel>
          <MotifInput
            id="group"
            name="userGroup"
            labelPosition="in"
            value={userDetails?.userGroup}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('personJob', userDetails?.personJob) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="job" position="in">
            Job
          </MotifLabel>
          <MotifInput
            id="personJob"
            name="personJob"
            labelPosition="in"
            value={userDetails?.personJob}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('personDepartment', userDetails?.personDepartment) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel
            aria-label="department"
            position="in"
          >
            Department
          </MotifLabel>
          <MotifInput
            id="personDepartment"
            name="personDepartment"
            labelPosition="in"
            value={userDetails?.personDepartment}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('personId', userDetails?.personId) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="id" position="in">
            ID
          </MotifLabel>
          <MotifInput
            id="personId"
            name="personId"
            labelPosition="in"
            value={userDetails?.personId}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('permission', userDetails?.permission) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel
            aria-label="Permission"
            position="in"
          >
            Permission
          </MotifLabel>
          <MotifInput
            id="Permission"
            name="permission"
            labelPosition="in"
            value={userDetails?.permission}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('systemAccount', userDetails?.systemAccount) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel
            aria-label="System Account"
            position="in"
          >
            System Account
          </MotifLabel>
          <MotifInput
            id="systemAccount"
            name="systemAccount"
            labelPosition="in"
            value={userDetails?.systemAccount}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
    </div>
  )
}
